/**
 * The signed-in employee, their role, and the way out. Sits in the shell header.
 *
 * The role is shown because in a bank "why can't I see the audit search" is answered by "you are
 * signed in as an agent", and an employee who cannot see their own role has to ask someone.
 */

import { useTranslation } from "react-i18next";

import { Button } from "../ui/Button";
import { useSession } from "./SessionProvider";

export function SessionMenu(): JSX.Element | null {
  const { t } = useTranslation("auth");
  const { identity, signOut } = useSession();

  if (!identity) return null;

  return (
    <div className="flex items-center gap-3">
      <span className="flex flex-col leading-tight">
        {/* A label plus an isolated name, never the name interpolated into a sentence: a Latin
            name inside Arabic text reorders the sentence around it unless it is wrapped in bdi,
            and bdi cannot be injected through interpolation. */}
        <span className="text-label-md text-textPrimary">
          <bdi>{identity.display_name}</bdi>
        </span>
        <span className="text-label-sm text-textMuted">
          {t(`roles.${identity.role}`)}
        </span>
      </span>
      <Button type="button" variant="ghost" size="sm" onClick={() => void signOut()}>
        {t("session.signOut")}
      </Button>
    </div>
  );
}
